export const INITIALIZE_FILTERS = 'filters/INITIALIZE_FILTERS'
export const SET_FILTERS_CONFIGURATION = 'filters/SET_FILTERS_CONFIGURATION'
export const COMMIT_FILTERS_CONFIGURATION = 'filters/COMMIT_FILTERS_CONFIGURATION'
export const SET_FILTERS_ERROR = 'filters/SET_FILTERS_ERROR'
export const SET_LOADING = 'filters/SET_LOADING'
export const SET_BLOCKING = 'filters/SET_BLOCKING'
export const SET_LAST_DATA_PATH_ENCODED = 'filters/SET_LAST_DATA_PATH_ENCODED'
export const REVERT_FILTERS_CONFIGURATION = 'filters/REVERT_FILTERS_CONFIGURATION'
export const SET_SEARCH_REQUEST_ID = 'filters/SET_SEARCH_REQUEST_ID'
export const CLEAR_SEARCH_REQUEST_ID = 'filters/CLEAR_SEARCH_REQUEST_ID'
export const PUSH_MODAL = 'filters/PUSH_MODAL'
export const POP_MODAL = 'filters/POP_MODAL'
